<!-- <div class="container">
    <div class="zoom-container">
        <div id="meetingSDKElement">
        </div>
    </div>
</div> -->
<div *ngIf="loading" class="spinner-bg">
    <div class="spinner-container">
    <img src="../assets/img/loader.gif" alt="">
    <span class="spinner-message">Obteniendo información del evento...</span>
    </div>
</div>
<router-outlet></router-outlet>